import React from 'react';
import styled from 'styled-components';
import InlineSVGImport from 'react-inlinesvg';
import type { FunctionComponent } from 'react';

interface SVGProps {
  width?: string;
  height?: string;
  color?: string;
  src: string;
}

const InlineSVG = InlineSVGImport as FunctionComponent<{ src: string; style?: React.CSSProperties }>;

const SVGWrapper: React.FC<SVGProps> = ({ width = '24px', height = '24px', color, src }) => (
  <InlineSVG src={src} style={{ width, height, color, fill: color }} />
);

export const CustomSVG = styled(SVGWrapper)<SVGProps>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  color: ${({ color }) => color};

  & path {
    fill: ${({ color }) => color};
  }
`;

export default CustomSVG;
